/**
 * Six-week programme purchase screen — v2 (sections/section-six-weeks-program-v2.liquid).
 *
 * Purchase contract (v1, assets/six-weeks-program.js, retired 2026-10-07):
 *   bundle  <programme>-<meals>-meals-weekly-6-deliveries
 *   add-ons add-on-5-breakfasts-weekly-6-deliveries, add-on-5-protein-shakes-42g-weekly-6-deliveries
 *   cart    _plan, _delivery_date (Y-m-d, Sunday/Wednesday), _checkout_delivery_date;
 *           stale _filter / weekActive blanked; no _delivery_compositions; no discount.
 * Presentation per the 2026-10-07 design panel: programme summary from the
 * quiz, meal/add-on cards with prices, start date as step 4, an itemised bag
 * (meals over six weeks, dates, line items, per meal / per delivery, Rewards
 * with conditions) and a fixed bar on mobile.
 *
 * Shine partner (?partner=shine, from /pages/six-weeks-program-shine): that LP
 * sells meals + Shine's 6-week challenge in two plans, Full Access and Hybrid.
 * Both cards show, one plan at a time; &shine=hybrid starts Hybrid in the bag,
 * anything else Full Access (removable). It is paid once, not per delivery:
 * in the total but not in the per-delivery or per-meal prices, nor in Rewards.
 */
(function () {
  var PROGRAMS = ['female-muscle-gain', 'female-weight-loss', 'male-muscle-gain', 'male-weight-loss', 'glp1'];
  var MEALS = ['8', '10', '12'];
  var LEGACY_PLAN_TO_PROGRAM = { 'lean-muscle': 'female-muscle-gain', power: 'male-muscle-gain', 'glp-1': 'glp1' };
  var DATES_KEY = 'delivery_dates_and_cut_offs';
  var EXTRA_SUNDAYS = 8;
  var DAY_MS = 24 * 60 * 60 * 1000;

  // Calendar weeks, not milliseconds: adding 7 x 24 h across the November
  // clock change lands on Saturday 11 pm in Toronto (panel QA, 2026-10-07).
  function addWeeks(ts, weeks) {
    var d = new Date(Number(ts));
    d.setDate(d.getDate() + 7 * weeks);
    return d.getTime();
  }
  var BREAKFASTS = 'add-on-5-breakfasts-weekly-6-deliveries';
  var SHINE = 'shine-6-week-challenge';               // Full Access
  var SHINE_HYBRID = 'shine-6-week-challenge-hybrid';
  var SHINE_PLANS = [SHINE, SHINE_HYBRID];
  var SHINE_LINES = {};
  SHINE_LINES[SHINE] = ['Shine 6-Week Challenge · Full Access', 'Unlimited studio + Shine Online, 6 weeks'];
  SHINE_LINES[SHINE_HYBRID] = ['Shine 6-Week Challenge · Hybrid', '12 studio classes + Shine Online, 6 weeks'];
  function isShine(handle) { return SHINE_PLANS.indexOf(handle) !== -1; }

  var root = document.querySelector('[data-swp]');
  if (!root) return;

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var el = {
    summary: $('[data-swp-program-summary]'),
    programName: $('[data-swp-program-name]'),
    programBlurb: $('[data-swp-program-blurb]'),
    programList: $('[data-swp-program-list]'),
    date: $('[data-swp-date]'),
    dateNote: $('[data-swp-date-note]'),
    dateSoon: $('[data-swp-date-soon]'),
    dateLater: $('[data-swp-date-later]'),
    dateLaterLabel: $('[data-swp-date-later-label]'),
    spots: $('[data-swp-spots]'),
    heroBig: $('[data-swp-hero-big]'),
    heroSub: $('[data-swp-hero-sub]'),
    heroDates: $('[data-swp-hero-dates]'),
    thumbs: $('[data-swp-thumbs]'),
    thumbsCaption: $('[data-swp-thumbs-caption]'),
    checkDay: $('[data-swp-check-day]'),
    lines: $('[data-swp-lines]'),
    total: $('[data-swp-total]'),
    totalNote: $('[data-swp-total-note]'),
    sezzle: $('[data-swp-sezzle]'),
    sezzleAmount: $('[data-swp-sezzle-amount]'),
    unit: $('[data-swp-unit]'),
    rewards: $('[data-swp-rewards]'),
    rewardsTitle: $('[data-swp-rewards-title]'),
    checkout: $('[data-swp-checkout]'),
    error: $('[data-swp-error]'),
    preview: $('[data-swp-preview]'),
    bar: $('[data-swp-bar]'),
    barTotal: $('[data-swp-bar-total]'),
    barSub: $('[data-swp-bar-sub]'),
    bag: document.getElementById('swp-bag'),
    recommended: $('.swp__recommended'),
    change: $('[data-swp-change-program]'),
    packageBadge: $('.swp__badge--recommended'),
    status: $('[data-swp-status]')
  };

  var state = {
    program: null,
    meals: null,
    fromQuiz: false,
    partner: null,     // 'shine' when the lead came from the Shine LP
    shinePlan: null,   // the Shine plan the bag starts with (SHINE or SHINE_HYBRID)
    addons: [],
    packageBreakfasts: false, // breakfasts came in through the package card
    bundle: null,      // { handle, title, variantId, price } of the chosen bundle
    mealsValue: null,  // cents: the six shown deliveries' meals at their single price
    tierPrices: {},    // "<programme>-<meals>" -> price in cents | null
    addonData: {},     // handle -> { title, variantId, price, image } | null
    loadToken: 0
  };

  // ---------- helpers ----------
  function handleFor(program, meals) {
    return program + '-' + meals + '-meals-weekly-6-deliveries';
  }

  function money(cents) {
    var value = Number(cents) / 100;
    return '$' + value.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function showError(message) {
    el.error.textContent = message || '';
    el.error.hidden = !message;
  }

  function programButton(program) {
    return root.querySelector('[data-program="' + program + '"]');
  }

  function shortDate(ts) {
    return new Date(Number(ts)).toLocaleString('en-CA', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function longDate(ts) {
    return new Date(Number(ts)).toLocaleString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function weekdayName(ts) {
    return new Date(Number(ts)).toLocaleString('en-CA', { weekday: 'long' });
  }

  function toYmd(ts) {
    var d = new Date(Number(ts));
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function weekAfter(baseWeek, offset) {
    return ((baseWeek - 1 + offset) % 8) + 1;
  }

  // ---------- choice resolution ----------
  function initialChoice() {
    var params = new URLSearchParams(window.location.search);
    var program = params.get('program');
    var fromQuiz = PROGRAMS.indexOf(program) !== -1;
    if (!fromQuiz) {
      program = LEGACY_PLAN_TO_PROGRAM[params.get('plan')] || null;
      fromQuiz = PROGRAMS.indexOf(program) !== -1;
    }
    if (!fromQuiz) {
      program = PROGRAMS.indexOf(root.dataset.defaultProgram) !== -1 ? root.dataset.defaultProgram : PROGRAMS[0];
    }
    var meals = params.get('meals');
    if (MEALS.indexOf(meals) === -1) {
      meals = MEALS.indexOf(root.dataset.defaultMeals) !== -1 ? root.dataset.defaultMeals : '10';
    }
    // A link this page wrote after a manual pick carries picked=1: the
    // programme is the customer's choice, not a quiz recommendation.
    var picked = fromQuiz && params.get('picked') === '1';
    var partner = params.get('partner') === 'shine' ? 'shine' : null;
    var shinePlan = params.get('shine') === 'hybrid' ? SHINE_HYBRID : SHINE;
    return { program: program, meals: meals, fromQuiz: fromQuiz && !picked, picked: picked, partner: partner, shinePlan: shinePlan };
  }

  function syncUrl() {
    try {
      var url = new URL(window.location.href);
      // The programme goes in the link only once it was recommended or
      // chosen; a default must not come back as "from your quiz".
      if (state.fromQuiz || state.picked) url.searchParams.set('program', state.program);
      else url.searchParams.delete('program');
      if (state.picked && !state.fromQuiz) url.searchParams.set('picked', '1');
      else url.searchParams.delete('picked');
      url.searchParams.set('meals', state.meals);
      url.searchParams.delete('plan');
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // Convenience only.
    }
  }

  // ---------- step 1 · programme ----------
  function paintProgram() {
    var btn = programButton(state.program);
    $$('[data-program]').forEach(function (b) {
      var on = b.dataset.program === state.program;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (btn) {
      el.programName.textContent = btn.dataset.name;
      el.programBlurb.textContent = btn.dataset.blurb;
    }
    // Recommended or already chosen: a summary with a way out. Otherwise the
    // list. The quiz label only while it is the quiz's own programme.
    var collapsed = state.listOpen ? false : (state.fromQuiz || state.picked);
    el.summary.hidden = !collapsed;
    el.programList.hidden = collapsed;
    if (el.recommended) el.recommended.textContent = state.fromQuiz ? 'Recommended from your quiz' : 'Your program';
    if (el.change) el.change.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    if (el.packageBadge) el.packageBadge.textContent = state.fromQuiz ? 'Recommended for your goal' : 'Recommended';
    paintBanner();
  }

  // The banner above shows women. For male-* programmes swap in the men's
  // photo set on this section (desktop <source> + mobile <img>); any other
  // programme gets the banner's own photo back.
  function paintBanner() {
    var media = document.querySelector('.lp-pk-program-banner__media');
    if (!media) return;
    var source = media.querySelector('picture source');
    var img = media.querySelector('img');
    if (!img) return;
    // The banner writes its default photo into data-orig-* (it may have
    // started with the alternate one); only fill them when it did not.
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
      if (source) source.dataset.origSrcset = source.getAttribute('srcset') || '';
    }
    var men = state.program.indexOf('male-') === 0;
    var d = root.dataset;
    var useMen = men && (d.bannerMenDesktop || d.bannerMenSrc);
    if (source) source.setAttribute('srcset', useMen && d.bannerMenDesktop ? d.bannerMenDesktop : source.dataset.origSrcset);
    img.setAttribute('srcset', useMen ? (d.bannerMenMobile || d.bannerMenDesktop) : img.dataset.origSrcset);
    img.setAttribute('src', useMen ? (d.bannerMenSrc || img.dataset.origSrc) : img.dataset.origSrc);
    media.classList.toggle('lp-pk-program-banner__media--alt', !!useMen);
  }

  // ---------- step 2 · meals per delivery ----------
  function loadTierPrices() {
    var program = state.program;
    return Promise.all(MEALS.map(function (m) {
      var key = program + '-' + m;
      if (key in state.tierPrices) return Promise.resolve();
      return fetchJson('/products/' + handleFor(program, m) + '.js')
        .then(function (p) { state.tierPrices[key] = p.variants && p.variants[0] ? p.variants[0].price : null; })
        .catch(function () { state.tierPrices[key] = null; });
    })).then(paintMeals);
  }

  function paintMeals() {
    $$('[data-meals]').forEach(function (b) {
      var m = b.dataset.meals;
      var on = m === state.meals;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var price = state.tierPrices[state.program + '-' + m];
      b.querySelector('[data-swp-per-meal]').textContent = price ? money(Math.round(price / (Number(m) * 6))) : '\u00a0';
      var tierTotal = b.querySelector('[data-swp-tier-total]');
      tierTotal.textContent = price ? money(price) + ' · ' + tierTotal.dataset.count : '\u00a0';
      // One badge on the page: the package's. No "Best value" competing.
      var best = b.querySelector('[data-swp-best]');
      if (best) best.hidden = true;
    });
    paintPackage();
  }

  // The middle card: 10 meals, with the 5 breakfasts unless the customer took
  // them off in step 3 (then it reads "10" and offers them back). Lit
  // whenever 10 meals are chosen.
  function paintPackage() {
    var card = root.querySelector('[data-package]');
    if (!card) return;
    var ten = state.tierPrices[state.program + '-10'];
    var bf = state.addonData[BREAKFASTS];
    var on = state.meals === '10';
    var withBf = state.addons.indexOf(BREAKFASTS) !== -1;
    var showBf = withBf || !on; // off the card, it always advertises the bundle
    card.classList.toggle('is-selected', on);
    card.setAttribute('aria-pressed', on ? 'true' : 'false');
    card.querySelector('[data-swp-package-num]').innerHTML = showBf ? '10 <small>+ 5</small>' : '10';
    card.querySelector('[data-swp-package-text]').textContent = showBf ? 'meals + breakfasts each delivery' : 'meals each delivery';
    // Same rows as the other two cards: price per meal first (breakfasts
    // count as meals, as in the bag), then the total with what it buys.
    var withBfPrice = showBf && bf;
    var total = ten ? ten + (withBfPrice ? bf.price : 0) : null;
    var count = withBfPrice ? 90 : 60;
    card.querySelector('[data-swp-package-per-meal]').textContent = total ? money(Math.round(total / count)) : '\u00a0';
    card.querySelector('[data-swp-package-price-label]').textContent = withBfPrice ? 'per meal, breakfasts included' : 'per meal';
    card.querySelector('[data-swp-package-total]').textContent = total ? money(total) + ' · ' + (withBfPrice ? '60 meals + 30 breakfasts' : '60 meals') : '\u00a0';
    card.querySelector('[data-swp-package-hint]').hidden = !(on && !withBf && bf);
  }

  // ---------- step 3 · add-ons ----------
  function loadAddons() {
    return Promise.all($$('[data-addon]').map(function (b) {
      var handle = b.dataset.addon;
      if (handle in state.addonData) return Promise.resolve();
      return fetchJson('/products/' + handle + '.js')
        .then(function (p) {
          var v = p.variants && p.variants[0];
          state.addonData[handle] = v ? { title: p.title, variantId: v.id, price: v.price, image: p.featured_image } : null;
        })
        .catch(function () { state.addonData[handle] = null; });
    })).then(function () {
      if (!state.defaultApplied) {
        state.defaultApplied = true;
        if (state.meals === '10' && state.addonData[BREAKFASTS] && state.addons.indexOf(BREAKFASTS) === -1) {
          state.addons.push(BREAKFASTS);
          state.packageBreakfasts = true;
        }
        if (state.partner === 'shine' && !state.addons.some(isShine)) {
          // The plan the LP picked; the other one if that is unavailable.
          var plan = [state.shinePlan].concat(SHINE_PLANS).filter(function (h) { return state.addonData[h]; })[0];
          if (plan) state.addons.push(plan);
        }
      }
      paintAddons();
      paintMeals();
      paintBag();
    });
  }

  function paintAddons() {
    $$('[data-addon]').forEach(function (b) {
      var handle = b.dataset.addon;
      var data = state.addonData[handle];
      var on = state.addons.indexOf(handle) !== -1;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.querySelector('[data-swp-addon-cta]').textContent = on ? 'Added ✓' : 'Add';
      var partOfPackage = on && handle === BREAKFASTS && state.meals === '10';
      b.querySelector('[data-swp-addon-price]').textContent = data
        ? '+' + money(data.price) + ' for 6 weeks' + (partOfPackage ? ' · part of your 10 + 5 package' : '')
        : (handle in state.addonData ? 'Not available' : '\u00a0');
      b.disabled = handle in state.addonData && !data;
      var img = b.querySelector('[data-swp-addon-img]');
      if (data && data.image && !img.firstChild) {
        var i = document.createElement('img');
        i.src = data.image + (data.image.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        i.alt = '';
        i.loading = 'lazy';
        img.appendChild(i);
      }
    });
  }

  // ---------- step 4 · start date ----------
  function selectedOption() {
    return el.date.options[el.date.selectedIndex] || null;
  }

  function formatOption(ts) {
    var d = new Date(Number(ts));
    return d.toLocaleString('en-CA', { weekday: 'long', month: 'short', day: 'numeric' });
  }

  function buildDates(attempt) {
    var raw = null;
    try { raw = window.localStorage.getItem(DATES_KEY); } catch (error) { raw = null; }
    if (!raw) {
      if ((attempt || 0) < 50) setTimeout(function () { buildDates((attempt || 0) + 1); }, 100);
      else showError('We could not load the delivery dates. Please refresh the page.');
      return;
    }
    var next = (JSON.parse(raw) || {}).next_available_dates;
    if (!next) return;
    el.date.innerHTML = '';
    // A full intake week (owner, 2026-10-07): checkout stays open, but the
    // soonest week's dates go, so the sale starts with the next intake (the
    // backend counts it there: places sold over the limit roll forward).
    var firstSunday = next.sunday && next.sunday.timestamp ? Number(next.sunday.timestamp) : null;
    var notBefore = state.intakeFull && firstSunday ? addWeeks(firstSunday, 1) : null;
    function add(ts, offset, deadline) {
      if (touchesHoliday(ts)) return;
      if (notBefore && Number(ts) < notBefore) return;
      var o = new Option(formatOption(ts), String(ts));
      o.dataset.weekOffset = String(offset);
      if (deadline && deadline.year && deadline.month && deadline.month_day) {
        o.dataset.deadline = String(new Date(deadline.year, deadline.month - 1, deadline.month_day).getTime());
      }
      el.date.appendChild(o);
    }
    // Same dates and rotation-week arithmetic as the One Month Trial
    // (quiz-global.js buildDeliveryDatesWidget / getNextWeekValue).
    var sundayOpen = !!(next.sunday && next.sunday.show_sunday);
    var wednesdayOpen = !!(next.wednesday && next.wednesday.show_wednesday);
    if (sundayOpen) add(next.sunday.timestamp, 0, next.sunday.deadline);
    if (wednesdayOpen) add(next.wednesday.timestamp, 0, next.wednesday.deadline);
    if ((sundayOpen || wednesdayOpen) && next.sunday && next.sunday.timestamp) {
      var base = new Date(Number(next.sunday.timestamp));
      for (var i = sundayOpen ? 1 : 0; i <= EXTRA_SUNDAYS; i++) {
        var s = new Date(base);
        s.setDate(base.getDate() + 7 * i);
        add(s.getTime(), sundayOpen ? i : i + 1);
      }
    }
    renderDateChoices();
    onDateChange();
  }

  // ---------- holiday window ----------
  // Owner, 2026-10-07: no programme whose deliveries land in the holidays.
  // The window comes from the section setting (default "12-24 to 01-01") and
  // may wrap the new year. A start date is dropped when ANY of its six
  // deliveries falls inside it.
  var holiday = (function () {
    var m = /^\s*(\d{2})-(\d{2})\s*to\s*(\d{2})-(\d{2})\s*$/.exec(root.dataset.holidayBlackout || '');
    if (!m) return null;
    return { from: Number(m[1]) * 100 + Number(m[2]), to: Number(m[3]) * 100 + Number(m[4]) };
  })();

  function inHoliday(ts) {
    if (!holiday) return false;
    var d = new Date(Number(ts));
    var md = (d.getMonth() + 1) * 100 + d.getDate();
    return holiday.from <= holiday.to
      ? md >= holiday.from && md <= holiday.to
      : md >= holiday.from || md <= holiday.to;
  }

  function touchesHoliday(start) {
    for (var k = 0; k < 6; k++) {
      if (inHoliday(addWeeks(start, k))) return true;
    }
    return false;
  }

  // ---------- open date choices ----------
  // Dates are local midnight of the store's calendar day (see
  // snippets/delivery-dates-and-cut-offs.liquid), so they are formatted in
  // the browser's zone like the rest of this file; forcing a zone here would
  // shift them for anyone east of Toronto.
  function fmt(ts, opts) { return new Date(Number(ts)).toLocaleString('en-CA', opts); }
  function monthDay(ts) { return fmt(ts, { month: 'short', day: 'numeric' }); }

  function dateChoice(option, index, big) {
    var ts = Number(option.value);
    var day = weekdayName(ts);
    var label = document.createElement('label');
    label.className = big ? 'swp__date-card' : 'swp__date-chip';
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'swp-start';
    input.value = String(index);
    input.className = 'swp__date-input';
    input.checked = index === el.date.selectedIndex;
    label.appendChild(input);

    var spoken = [longDate(ts)];
    if (big) {
      var top = document.createElement('span');
      top.className = 'swp__date-day';
      top.textContent = day;
      var date = document.createElement('span');
      date.className = 'swp__date-big';
      date.textContent = monthDay(ts);
      label.appendChild(top);
      label.appendChild(date);
      if (option.dataset.deadline) {
        var by = document.createElement('span');
        by.className = 'swp__date-by';
        by.textContent = 'Order by ' + fmt(option.dataset.deadline, { weekday: 'short', month: 'short', day: 'numeric' }) + ', 9:59 am ET';
        label.appendChild(by);
        spoken.push(by.textContent);
      }
      var span = document.createElement('span');
      span.className = 'swp__date-span';
      span.textContent = '6 ' + day + 's, ' + monthDay(ts) + ' to ' + monthDay(addWeeks(ts, 5));
      label.appendChild(span);
      spoken.push(span.textContent);
    } else {
      var d = document.createElement('span');
      d.className = 'swp__date-chip-day';
      d.textContent = fmt(ts, { weekday: 'short' });
      var m = document.createElement('span');
      m.className = 'swp__date-chip-date';
      m.textContent = monthDay(ts);
      label.appendChild(d);
      label.appendChild(m);
    }
    input.setAttribute('aria-label', spoken.join('. '));
    input.addEventListener('change', function () {
      if (!input.checked) return;
      el.date.selectedIndex = index;
      paintDateChoices();
      onDateChange();
    });
    return label;
  }

  function renderDateChoices() {
    if (!el.dateSoon || !el.dateLater) return;
    el.dateSoon.innerHTML = '';
    el.dateLater.innerHTML = '';
    var options = Array.prototype.slice.call(el.date.options);
    // The soonest choices: the first date, plus the Wednesday when it is open
    // (it only ever sits in the first week). Everything else is a later Sunday.
    var soon = options.length > 1 && new Date(Number(options[1].value)).getDay() === 3 ? 2 : 1;
    options.forEach(function (o, i) {
      (i < soon ? el.dateSoon : el.dateLater).appendChild(dateChoice(o, i, i < soon));
    });
    el.dateSoon.classList.toggle('is-single', soon === 1);
    el.dateLaterLabel.hidden = options.length <= soon;
    paintDateChoices();
  }

  function paintDateChoices() {
    root.querySelectorAll('.swp__date-input').forEach(function (input) {
      var on = Number(input.value) === el.date.selectedIndex;
      input.checked = on;
      input.parentNode.classList.toggle('is-selected', on);
    });
  }

  function onDateChange() {
    var o = selectedOption();
    if (o) {
      var start = Number(o.value);
      var last = addWeeks(start, 5);
      el.dateNote.textContent = 'Your 6 deliveries: ' + longDate(start) + ' to ' + longDate(last) + ', every ' + weekdayName(start) + '. The menus below are for this start date.';
    }
    arrangePreview();
    paintBag();
  }

  // ---------- preview ----------
  function showRealQuantities(container) {
    container.querySelectorAll('.six-weeks-preview__item').forEach(function (item) {
      var qty = parseInt(item.dataset.quantity, 10);
      if (!qty || qty < 1) return;
      var badge = item.querySelector('.product-card__icon-quantity .quantity');
      if (badge) badge.textContent = qty + 'x';
    });
  }

  // Mobile list: one compact row per dish (photo, name, kcal and macros,
  // diet tags, quantity) instead of a full-height card per dish. Built from
  // the card's own data and placed next to it; CSS shows rows below 768px
  // and cards above. The card stays in the DOM because its details modal
  // lives inside it: tapping a row opens that modal.
  function textOf(node) { return node ? node.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function buildMealRows(container) {
    container.querySelectorAll('.six-weeks-preview__item').forEach(function (item) {
      var card = item.querySelector('.product-card');
      if (!card || item.querySelector('.swp-row')) return;
      var name = card.getAttribute('data-product-short-title') || textOf(card.querySelector('.short-title'));
      var qty = parseInt(item.dataset.quantity, 10) || 1;

      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'swp-row';
      row.setAttribute('data-swp-row', '');
      row.setAttribute('aria-label', name + ', ' + qty + (qty === 1 ? ' serving' : ' servings') + '. See details');

      var img = card.querySelector('.product-card--image img');
      var src = img ? (img.getAttribute('src') || '') : '';
      var thumb = document.createElement('span');
      thumb.className = 'swp-row__thumb';
      if (src) {
        var t = document.createElement('img');
        t.src = src.replace(/height=\d+/, 'height=192').replace(/width=\d+/, 'width=192');
        t.alt = '';
        t.loading = 'lazy';
        t.width = 64;
        t.height = 64;
        thumb.appendChild(t);
      }
      row.appendChild(thumb);

      var body = document.createElement('span');
      body.className = 'swp-row__body';
      var title = document.createElement('span');
      title.className = 'swp-row__name';
      title.textContent = name;
      body.appendChild(title);

      var facts = [];
      var kcal = card.querySelector('.kcal-tag small');
      if (kcal && textOf(kcal)) facts.push(textOf(kcal) + ' kcal');
      var letters = { protein: 'P', carbs: 'C', fats: 'F' };
      card.querySelectorAll('.product-card--macros .product-card--macros--item').forEach(function (m) {
        var smalls = m.querySelectorAll('small');
        var key = textOf(smalls[0]).replace(':', '').toLowerCase();
        var value = textOf(smalls[1]);
        if (letters[key] && value) facts.push(letters[key] + ' ' + value + 'g');
      });
      if (facts.length) {
        var line = document.createElement('span');
        line.className = 'swp-row__facts';
        line.textContent = facts.join(' · ');
        body.appendChild(line);
      }

      var tags = [];
      card.querySelectorAll('.product-card--content .restriction span').forEach(function (r) {
        var label = textOf(r);
        if (label && tags.indexOf(label) === -1) tags.push(label);
      });
      if (tags.length) {
        var tagLine = document.createElement('span');
        tagLine.className = 'swp-row__tags';
        tagLine.textContent = tags.slice(0, 2).join(' · ');
        body.appendChild(tagLine);
      }
      row.appendChild(body);

      var pill = document.createElement('span');
      pill.className = 'swp-row__qty' + (qty > 1 ? ' is-double' : '');
      pill.textContent = qty + 'x';
      row.appendChild(pill);

      item.appendChild(row);
    });
  }

  // Desktop cards show macros as a small stat row ("42g" over "Protein");
  // the shared card writes "Protein:" with a colon, which reads wrong as a
  // label under a number. Only the text changes; the card markup is shared.
  function tidyCardMacros(container) {
    container.querySelectorAll('.product-card--macros--item small:first-child').forEach(function (label) {
      label.textContent = label.textContent.replace(':', '').trim();
    });
  }

  // One photo per dish. Each card holds two copies of it (the card's and
  // its details modal's, at different sizes), so de-duplicating by URL let
  // both through; take the card's first image and key on the file name.
  function smallImage(src, px) {
    return src.replace(/height=\d+/, 'height=' + px).replace(/width=\d+/, 'width=' + px);
  }

  function thumbsOf(block, max) {
    var urls = [];
    var seen = {};
    block.querySelectorAll('.product-card').forEach(function (card) {
      if (urls.length >= max) return;
      var img = card.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
      var file = src.split('?')[0].split('/').pop();
      if (!src || seen[file]) return;
      seen[file] = true;
      urls.push(smallImage(src, 96));
    });
    return urls;
  }

  function arrangePreview() {
    var preview = el.preview.querySelector('#six-weeks-preview');
    if (!preview) return;
    var o = selectedOption();
    var baseWeek = parseInt(preview.dataset.activeWeek, 10) || 1;
    var offset = o ? parseInt(o.dataset.weekOffset, 10) || 0 : 0;
    var startWeek = weekAfter(baseWeek, offset);
    var startTs = o ? Number(o.value) : null;

    var blocks = {};
    preview.querySelectorAll('.six-weeks-preview__delivery').forEach(function (b) {
      b.hidden = true;
      b.style.display = 'none';
      b.open = false;
      blocks[b.dataset.week] = b;
    });

    for (var n = 0; n < 6; n++) {
      var b = blocks[String(weekAfter(startWeek, n))];
      if (!b) continue;
      var label = b.querySelector('[data-delivery-label]');
      var meta = b.querySelector('[data-delivery-meta]');
      var units = Number(b.dataset.units || 0);
      var dishes = b.querySelectorAll('.six-weeks-preview__item').length;
      var parts = [];
      if (startTs) parts.push(shortDate(addWeeks(startTs, n)));
      if (units) parts.push(units + ' meals' + (dishes && dishes < units ? ' (' + dishes + ' dishes, ' + (units - dishes) + ' doubled)' : ''));
      if (label) label.textContent = n === 0 ? 'Delivery 1 · your first box' : 'Delivery ' + (n + 1);
      if (meta) meta.textContent = parts.join(' · ') + (n === 0 ? '' : ' · different menu');

      // Closed deliveries still show their food: a strip of thumbnails in
      // the summary (collapsed content is otherwise rarely opened).
      var summary = b.querySelector('summary');
      var strip = summary.querySelector('.swp__strip');
      if (!strip) {
        strip = document.createElement('span');
        strip.className = 'swp__strip';
        thumbsOf(b, 6).forEach(function (src) {
          var i = document.createElement('img');
          i.src = src;
          i.alt = '';
          i.loading = 'lazy';
          strip.appendChild(i);
        });
        summary.appendChild(strip);
      }

      b.open = n === 0;
      b.hidden = false;
      b.style.display = '';
      preview.appendChild(b);
    }

    // What these exact six boxes cost bought one meal at a time: each dish's
    // own price × its quantity. Follows the start date, because each start
    // date ships different weeks of the rotation.
    var value = 0;
    var complete = true;
    preview.querySelectorAll('.six-weeks-preview__delivery').forEach(function (b) {
      if (b.hidden) return;
      b.querySelectorAll('.six-weeks-preview__item').forEach(function (item) {
        var card = item.querySelector('.product-card');
        var price = card ? parseFloat(card.getAttribute('data-product-price')) : NaN;
        var qty = parseInt(item.dataset.quantity, 10) || 1;
        if (isNaN(price)) { complete = false; return; }
        value += price * qty;
      });
    });
    state.mealsValue = complete && value > 0 ? Math.round(value * 100) : null;
    paintHeroThumbs();
  }

  // The bag's first-box row: five photos as an overlapping stack, a "+N"
  // chip for the dishes not pictured, and a caption that does the counting
  // (design review, 2026-10-07). Five separate tiles read as "5 meals" on a
  // 10-meal package. N counts distinct dishes, so a 12-meal box with two
  // doubled dishes says "+5", never "+7".
  function paintHeroThumbs() {
    el.thumbs.innerHTML = '';
    if (el.thumbsCaption) el.thumbsCaption.textContent = '';
    var preview = el.preview.querySelector('#six-weeks-preview');
    if (!preview) return;
    var first = Array.prototype.find.call(preview.querySelectorAll('.six-weeks-preview__delivery'), function (b) { return !b.hidden; });
    if (!first) return;
    var all = thumbsOf(first, 99);
    all.slice(0, 5).forEach(function (src) {
      var i = document.createElement('img');
      i.src = src;
      i.alt = '';
      i.loading = 'lazy';
      el.thumbs.appendChild(i);
    });
    var more = all.length - 5;
    if (more > 0) {
      var chip = document.createElement('span');
      chip.className = 'swp__thumbs-more';
      chip.textContent = '+' + more;
      el.thumbs.appendChild(chip);
    }
    el.thumbs.hidden = all.length === 0;

    var meals = Number(state.meals);
    var dishes = all.length;
    var caption = 'Your first box: ' + meals + ' meals' + (dishes && dishes < meals ? ' (' + dishes + ' dishes)' : '');
    if (state.addons.indexOf(BREAKFASTS) !== -1 && state.addonData[BREAKFASTS]) caption += ' + 5 breakfasts';
    if (el.thumbsCaption) el.thumbsCaption.textContent = caption;
    el.thumbs.setAttribute('aria-label', caption);
  }


  function loadPreview() {
    var token = ++state.loadToken;
    var handle = handleFor(state.program, state.meals);
    // The bag no longer waits for the preview: the price comes from the
    // catalogue. The preview fills in the meals and the one-by-one value.
    var known = catalog && catalog.bundles ? catalog.bundles[handle] : null;
    state.bundle = known && known.available
      ? { handle: handle, title: known.title, variantId: Number(known.variantId), price: Number(known.price) }
      : null;
    paintBag();
    el.preview.innerHTML = '<p class="swp__status">Loading your program…</p>';

    // First load: the request the section started while the page was parsing.
    var early = window.__swpPreview;
    var request;
    if (early && early.handle === handle) {
      request = early.text;
      window.__swpPreview = null;
    } else {
      request = fetch('/products/' + handle + '?view=six-weeks-v2', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
    }

    return request
      .then(function (html) {
        if (token !== state.loadToken) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var preview = doc.querySelector('#six-weeks-preview');
        if (!preview) throw new Error('no preview');
        state.bundle = {
          handle: handle,
          title: preview.dataset.title,
          variantId: Number(preview.dataset.variantId),
          price: Number(preview.dataset.price)
        };
        showRealQuantities(preview);
        // Lazy: on mobile the cards are hidden behind compact rows, and six
        // of eight weeks start closed; eager images were all downloaded.
        preview.querySelectorAll('img').forEach(function (img) { img.setAttribute('loading', 'lazy'); });
        tidyModals(preview);
        buildMealRows(preview);
        tidyCardMacros(preview);
        el.preview.innerHTML = '';
        el.preview.appendChild(document.importNode(preview, true));
        arrangePreview();
        showError('');
        paintBag();
      })
      .catch(function (error) {
        if (token !== state.loadToken) return;
        // eslint-disable-next-line no-console
        console.warn('six-weeks-program-v2: bundle unavailable', handle, error);
        state.bundle = null;
        el.preview.innerHTML = '<p class="swp__status">This program is not available right now. Please try another option or talk to our team.</p>';
        paintBag();
      });
  }

  // ---------- bag ----------
  function paintBag() {
    var meals = Number(state.meals);
    var totalMeals = meals * 6;
    var btn = programButton(state.program);
    var programLabel = btn ? btn.dataset.name : '';
    var extras = [];
    var total = 0;
    var ready = !!state.bundle;

    el.lines.innerHTML = '';
    function line(title, sub, cents, priceClass) {
      var li = document.createElement('li');
      var left = document.createElement('span');
      left.className = 'swp__line-name';
      left.textContent = title;
      if (sub) {
        var s = document.createElement('small');
        s.textContent = sub;
        left.appendChild(s);
      }
      var right = document.createElement('span');
      if (priceClass) right.className = priceClass;
      right.textContent = cents === null ? '' : money(cents);
      li.appendChild(left);
      li.appendChild(right);
      el.lines.appendChild(li);
    }

    // "You save" sits under the programme line it belongs to: the
    // one-by-one comparison covers the programme meals only, and next to a
    // Total that includes add-ons it read as if one by one were cheaper.
    // Shown only where the saving is large enough to be credible (10%+):
    // a 2-3% crossed-out figure on a four-digit price reads as trivial.
    var saving = state.bundle && state.mealsValue ? state.mealsValue - state.bundle.price : 0;
    var savingPct = state.bundle && state.mealsValue ? saving / state.mealsValue : 0;
    if (state.bundle) {
      line('6-week program', meals + ' meals × 6 deliveries', state.bundle.price, 'swp__line-price--program');
      total += state.bundle.price;
      if (saving > 0 && savingPct >= 0.10) {
        var save = document.createElement('div');
        save.className = 'swp__line-save';
        var was = document.createElement('span');
        was.className = 'swp__line-save-was';
        was.appendChild(document.createTextNode('Same ' + totalMeals + ' meals one by one '));
        var strike = document.createElement('s');
        strike.textContent = money(state.mealsValue);
        was.appendChild(strike);
        var pill = document.createElement('span');
        pill.className = 'swp__savings-pill';
        pill.textContent = 'You save ' + money(saving) + ' (' + Math.round(savingPct * 100) + '%)';
        save.appendChild(was);
        save.appendChild(pill);
        el.lines.lastChild.appendChild(save);
      }
    }
    var oneOff = 0; // paid once, not per delivery (the Shine challenge)
    state.addons.forEach(function (handle) {
      var a = state.addonData[handle];
      if (!a) { ready = false; return; }
      total += a.price;
      if (isShine(handle)) {
        line(SHINE_LINES[handle][0], SHINE_LINES[handle][1], a.price);
        oneOff += a.price;
        return;
      }
      var name = handle.indexOf('breakfast') !== -1 ? '5 Breakfasts' : '5 Protein Shakes';
      line(name, '5 × 6 deliveries', a.price);
      extras.push('30 ' + (handle.indexOf('breakfast') !== -1 ? 'breakfasts' : 'shakes'));
    });
    var hasShine = oneOff > 0;

    // Breakfasts are meals (shakes are not): they count in the headline and
    // in the per-meal price, with their own price in the numerator.
    var bfData = state.addons.indexOf(BREAKFASTS) !== -1 ? state.addonData[BREAKFASTS] : null;
    var bfCount = bfData ? 30 : 0;
    var mealCount = totalMeals + bfCount;
    var mealSpend = state.bundle ? state.bundle.price + (bfData ? bfData.price : 0) : 0;
    el.heroBig.textContent = mealCount + ' meals over 6 weeks';
    var shakes = extras.filter(function (x) { return x.indexOf('shakes') !== -1; });
    // One line (owner, 2026-10-07): the counts already sit in the headline
    // above and in "Your first box" below, so this names the programme only.
    el.heroSub.textContent = programLabel + (shakes.length ? ' · + shakes' : '') + (hasShine ? ' · + Shine training' : '');

    var o = selectedOption();
    if (o) {
      var start = Number(o.value);
      el.heroDates.textContent = shortDate(start) + ' → ' + shortDate(addWeeks(start, 5));
      el.checkDay.textContent = 'Delivered every ' + weekdayName(start) + ' for 6 weeks';
    }

    var perDelivery = Math.round((total - oneOff) / 6);
    el.total.textContent = state.bundle ? money(perDelivery) : '';
    // The total shows once (owner, 2026-10-07): with no add-ons it is the
    // programme line above, so this only says how it is paid; with add-ons
    // the sum appears nowhere else, so it is named here.
    var hasAddons = state.addons.some(function (h) { return !!state.addonData[h]; });
    if (el.totalNote) {
      // The sum in bold, a touch larger than the words around it (owner,
      // 2026-10-14): clear without competing with the per-delivery price.
      el.totalNote.textContent = '';
      if (!state.bundle) {
        el.totalNote.textContent = '\u00a0';
      } else if (hasShine || hasAddons) {
        var sum = document.createElement('strong');
        sum.className = 'swp__total-note-sum';
        sum.textContent = money(total);
        el.totalNote.appendChild(sum);
        el.totalNote.appendChild(document.createTextNode(hasShine ? ' in total with Shine, paid once at checkout' : ' in total, paid once at checkout'));
      } else {
        el.totalNote.textContent = 'Paid once at checkout';
      }
    }
    el.unit.innerHTML = '';
    if (state.bundle) {
      [
        [bfData ? 'Per meal, breakfasts included' : 'Per meal', money(Math.round(mealSpend / mealCount))]
      ].forEach(function (pair) {
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        dt.textContent = pair[0];
        var dd = document.createElement('dd');
        dd.textContent = pair[1];
        row.appendChild(dt);
        row.appendChild(dd);
        el.unit.appendChild(row);
      });
    }

    // Rewards: the programme price only (add-ons not counted until the
    // owner says otherwise), always with its conditions.
    el.rewards.hidden = !state.bundle;
    if (state.bundle) el.rewardsTitle.textContent = 'Earn ' + money(state.bundle.price) + ' back in rewards';

    // No price on this button: the Total sits right above it. The mobile
    // bar keeps its price, because it shows when the summary is off screen.
    el.checkout.textContent = 'Continue to checkout';
    el.checkout.disabled = !ready || !el.date.value;

    paintHeroThumbs();
    if (el.status && state.bundle) el.status.textContent = 'Updated: ' + el.heroSub.textContent + ', total ' + money(total);
    if (el.sezzle) {
      var sezzleMin = Number(el.sezzle.dataset.min || 0) * 100;
      var showSezzle = !!state.bundle && total >= sezzleMin;
      el.sezzle.hidden = !showSezzle;
      if (showSezzle) el.sezzleAmount.textContent = money(Math.round(total / 4));
    }
    paintBar();
    el.barTotal.textContent = state.bundle ? money(perDelivery) + ' / delivery' : '';
    el.barSub.textContent = state.bundle ? money(total) + ' total, paid once' : '\u00a0';
  }

  // ---------- sticky bag ----------
  // Fitting the bag to the window is CSS now (six-weeks-program-v2.css,
  // "bag on a laptop"): it scrolls inside, with the checkout button pinned.
  // Sticking it by its bottom edge hid the top of it behind the header on a
  // 14" MacBook (2026-10-13).

  // ---------- spots ----------
  function loadSpots() {
    var url = root.dataset.slotsUrl;
    if (!url || typeof fetch !== 'function') return;
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'omit', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (body) {
        var s = body && body.data;
        if (!s || s.remaining === null || s.remaining === undefined || !s.counter_trustworthy) return;
        var full = !!(s.is_full || s.remaining <= 0);
        if (full && !state.intakeFull) {
          state.intakeFull = true;
          buildDates(0);
        }
        var firstOption = el.date.options[0];
        el.spots.textContent = full
          ? "This week's places are taken. Order now to hold your place in the next intake" + (firstOption ? ', starting ' + longDate(firstOption.value) : '') + '.'
          : s.remaining >= s.slots_per_week
            ? s.slots_per_week + ' spots each week'
            : s.remaining + ' of ' + s.slots_per_week + ' spots left this week';
        el.spots.classList.toggle('is-full', !!(s.is_full || s.remaining <= 0));
        el.spots.hidden = false;
      })
      .catch(function () { el.spots.hidden = true; });
  }

  // ---------- checkout ----------
  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' HTTP ' + r.status);
      return r.json();
    });
  }

  function checkout() {
    if (!state.bundle || !el.date.value) return;
    var ts = el.date.value;
    // Cart order, top to bottom: the bundle, the per-delivery add-ons, then
    // the Shine challenge. One /cart/add.js with several items lands them in
    // no fixed order (2026-10-13: the same array gave two different orders),
    // while each single add goes to the top. So add one at a time, last
    // line first.
    var items = [{ id: state.bundle.variantId, quantity: 1 }];
    // Add-ons in the order of their cards (breakfasts, shakes), Shine last.
    var addonOrder = $$('[data-addon]').map(function (b) { return b.dataset.addon; })
      .filter(function (h) { return !isShine(h); }).concat(SHINE_PLANS);
    addonOrder.forEach(function (h) {
      var a = state.addons.indexOf(h) !== -1 ? state.addonData[h] : null;
      if (a) items.push({ id: a.variantId, quantity: 1 });
    });
    el.checkout.disabled = true;
    el.checkout.textContent = 'Taking you to checkout…';
    showError('');
    postJson('/cart/clear.js')
      .then(function () {
        return postJson('/cart/update.js', {
          attributes: {
            _plan: '6-Week Program',
            _delivery_date: toYmd(ts),
            _checkout_delivery_date: 'delivery - ' + formatOption(ts),
            _partner: state.partner || '',
            _filter: '',
            weekActive: ''
          }
        });
      })
      .then(function () {
        return items.slice().reverse().reduce(function (chain, item) {
          return chain.then(function () { return postJson('/cart/add.js', { items: [item] }); });
        }, Promise.resolve());
      })
      .then(function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'go_to_checkout_button_click', source: 'six-weeks-program-v2', program: state.program, meals: state.meals, partner: state.partner, shine: state.addons.indexOf(SHINE) !== -1 ? 'full-access' : (state.addons.indexOf(SHINE_HYBRID) !== -1 ? 'hybrid' : false) });
        window.location.href = '/checkout?discount=%20';
      })
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.error('six-weeks-program-v2: checkout failed', error);
        showError('Something went wrong adding your program to your cart. Please try again.');
        paintBag();
      });
  }

  // ---------- meal modal (same behaviour as v1) ----------
  var lastOpener = null;
  function closeMealModals() {
    var open = $$('.card-modal-wrapper').some(function (w) { return w.style.display === 'flex'; });
    $$('.card-modal-wrapper').forEach(function (w) { w.style.display = 'none'; });
    document.body.classList.remove('no-scroll');
    if (open && lastOpener && document.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }

  // The shared card's modal markup has a Portuguese close label, a URL as
  // the opener's name and no dialog role; fix them on the v2 copy only.
  // Dialog semantics on the shared modal markup, once per dish (the card
  // links are labelled in Liquid by snippets/swp-meal-card.liquid).
  function tidyModals(container) {
    container.querySelectorAll('.card-modal-wrapper').forEach(function (wrapper, i) {
      var modal = wrapper.querySelector('.card-modal');
      if (!modal) return;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      var title = modal.querySelector('.modal-title');
      if (title) {
        title.id = 'swp-meal-title-' + i;
        modal.setAttribute('aria-labelledby', title.id);
      }
    });
  }



  // ---------- mobile bar ----------
  var barSeen = { bag: false, section: true };
  function paintBar() {
    if (!el.bar) return;
    var desktop = window.matchMedia('(min-width: 1020px)').matches;
    el.bar.hidden = desktop || !state.bundle || barSeen.bag || !barSeen.section;
    document.body.classList.toggle('swp-bar-on', !el.bar.hidden);
  }
  function watchBag() {
    if (!el.bar || !el.bag) return;
    if (!('IntersectionObserver' in window)) { el.bar.hidden = true; return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === el.bag) barSeen.bag = e.isIntersecting;
        else barSeen.section = e.isIntersecting;
      });
      paintBar();
    }, { threshold: 0.05 });
    io.observe(el.bag);
    io.observe(root.querySelector('.swp__layout') || root);
  }


  // ---------- wiring ----------
  function selectProgram(program) {
    var changed = program !== state.program;
    if (changed && state.fromQuiz) state.fromQuiz = false;
    if (changed || !state.fromQuiz) state.picked = true;
    var wasOpen = state.listOpen;
    state.listOpen = false;
    state.program = program;
    paintProgram();
    if (wasOpen && el.change) el.change.focus();
    if (!changed) { syncUrl(); return; }
    syncUrl();
    loadTierPrices();
    loadPreview();
  }

  // Prices rendered by Shopify into the page (see the data-swp-catalog script
  // in the section; it sits before the .swp root, so look it up on document). Seeds the same state the /products/*.js calls filled, so
  // loadTierPrices/loadAddons find every key present and fetch nothing.
  var catalog = (function () {
    try { return JSON.parse((document.querySelector('[data-swp-catalog]') || {}).textContent || 'null'); } catch (e) { return null; }
  })();
  function seedCatalog() {
    if (!catalog) return;
    var bundles = catalog.bundles || {};
    PROGRAMS.forEach(function (p) {
      MEALS.forEach(function (m) {
        var b = bundles[handleFor(p, m)];
        if (b && b.available) state.tierPrices[p + '-' + m] = b.price;
      });
    });
    var addons = catalog.addons || {};
    Object.keys(addons).forEach(function (h) { state.addonData[h] = addons[h]; });
  }

  function init() {
    var choice = initialChoice();
    seedCatalog();
    state.program = choice.program;
    state.meals = choice.meals;
    state.fromQuiz = choice.fromQuiz;
    state.picked = choice.picked;
    state.partner = choice.partner;
    state.shinePlan = choice.shinePlan;
    var partnerStep = $('[data-swp-partner="shine"]');
    if (partnerStep) partnerStep.hidden = state.partner !== 'shine';
    paintProgram();
    paintMeals();
    paintAddons();
    syncUrl();
    buildDates(0);
    loadTierPrices();
    loadAddons();
    loadPreview();
    loadSpots();
    watchBag();

    root.addEventListener('click', function (event) {
      var info = event.target.closest('.one-month-info, [data-swp-row], .six-weeks-preview .see-all, .six-weeks-preview .product-card--image');
      if (info && root.contains(info)) {
        event.preventDefault();
        var card = info.hasAttribute('data-swp-row')
          ? info.closest('.six-weeks-preview__item').querySelector('.product-card')
          : info.closest('.product-card');
        // One modal per dish, at the end of the preview (lean preview, 2026-10-07).
        var wrapper = card && root.querySelector('.card-modal-wrapper[data-swp-modal-for="' + card.dataset.productId + '"]');
        if (wrapper) {
          lastOpener = info;
          wrapper.style.display = 'flex';
          document.body.classList.add('no-scroll');
          var closer = wrapper.querySelector('.close-modal');
          if (closer) closer.focus();
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'product_modal_opened', product_handle: card.dataset.productHandle, title: card.dataset.productShortTitle, product_id: card.dataset.productId, variant_id: card.dataset.variantId, source: 'six-weeks-program-v2' });
        }
        return;
      }
      if (event.target.closest('.modal-overlay, .close-modal')) {
        event.preventDefault();
        closeMealModals();
        return;
      }
      if (event.target.closest('[data-swp-change-program]')) {
        state.listOpen = true;
        paintProgram();
        var current = programButton(state.program);
        if (current) current.focus();
        return;
      }
      if (event.target.closest('[data-swp-bar-cta]')) {
        event.preventDefault();
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.bag.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
        el.bag.focus({ preventScroll: true });
        return;
      }
      var btn = event.target.closest('button');
      if (!btn || !root.contains(btn)) return;
      if (btn.dataset.program) {
        selectProgram(btn.dataset.program);
      } else if (btn.dataset.package) {
        var mealsChanged = state.meals !== '10';
        state.meals = '10';
        if (state.addonData[BREAKFASTS] && state.addons.indexOf(BREAKFASTS) === -1) {
          state.addons.push(BREAKFASTS);
          state.packageBreakfasts = true;
        }
        paintMeals();
        paintAddons();
        syncUrl();
        if (mealsChanged) loadPreview(); else paintBag();
      } else if (btn.dataset.meals) {
        if (btn.dataset.meals === state.meals) return;
        // Leaving the package drops the breakfasts it brought; breakfasts the
        // customer added in step 3 stay with 8 or 12.
        if (state.packageBreakfasts) {
          state.addons = state.addons.filter(function (x) { return x !== BREAKFASTS; });
          state.packageBreakfasts = false;
        }
        state.meals = btn.dataset.meals;
        paintMeals();
        paintAddons();
        syncUrl();
        loadPreview();
      } else if (btn.dataset.addon) {
        var h = btn.dataset.addon;
        var at = state.addons.indexOf(h);
        if (at === -1) {
          if (!state.addonData[h]) return;
          // One Shine plan at a time: adding one swaps out the other.
          if (isShine(h)) state.addons = state.addons.filter(function (x) { return !isShine(x); });
          state.addons.push(h);
        } else {
          state.addons.splice(at, 1);
          if (h === BREAKFASTS) state.packageBreakfasts = false;
        }
        paintAddons();
        paintMeals();
        paintBag();
      } else if (btn === el.checkout) {
        checkout();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeMealModals(); return; }
      if ((event.key === 'Enter' || event.key === ' ') && event.target.closest && event.target.closest('.swp .close-modal')) {
        event.preventDefault();
        closeMealModals();
      }
    });

    el.date.addEventListener('change', onDateChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
